import { UserWithBrokerMandate } from 'models/user';
import endpoint from 'shared/api';

import {
  EMAIL_UPDATE_SEND_MAGIC_LINK,
  EMAIL_UPDATE_START,
  EMAIL_UPDATE_UPDATE_EMAIL,
  EMAIL_UPDATE_VERIFY_CURRENT_EMAIL,
  EMAIL_UPDATE_VERIFY_MAGIC_LINK,
} from '../constants';

export type EmailUpdateResponse = {
  requestId: 'string';
};

export const getAccountInfo = async (): Promise<UserWithBrokerMandate> => {
  const { data } = await endpoint.getAccountInfo();
  return data;
};

export const start = async (): Promise<EmailUpdateResponse> => {
  const { data } = await endpoint.network.post(EMAIL_UPDATE_START);
  return data;
};

type VerifyCurrentEmailInput = {
  code: string;
  requestId: string;
};

export const verifyCurrentEmail = async ({
  code,
  requestId,
}: VerifyCurrentEmailInput): Promise<EmailUpdateResponse> => {
  const { data } = await endpoint.network.post(
    EMAIL_UPDATE_VERIFY_CURRENT_EMAIL,
    {
      requestId,
      code,
    }
  );
  return data;
};

type SendMagicLinkInput = {
  requestId: string;
  newEmail: string;
};

export const sendMagicLink = async ({
  requestId,
  newEmail,
}: SendMagicLinkInput): Promise<void> => {
  const { data } = await endpoint.network.post(EMAIL_UPDATE_SEND_MAGIC_LINK, {
    requestId,
    newEmail,
  });
  return data;
};

export type VerifyMagicLinkResponse = {
  requestId: string;
  newEmail: string;
};

export const verifyMagicLink = async (
  magicLinkToken: string
): Promise<VerifyMagicLinkResponse> => {
  const { data } = await endpoint.network.post(EMAIL_UPDATE_VERIFY_MAGIC_LINK, {
    magicLinkToken,
  });
  return data;
};

export const updateEmail = async (requestId: string): Promise<void> => {
  const { data } = await endpoint.network.patch(EMAIL_UPDATE_UPDATE_EMAIL, {
    requestId,
  });
  return data;
};
